/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'components/react-validation/components/form';
// import emptyImages from 'assets/img/empty-images.svg';
// import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

import * as Vali from 'helper/validator-helper';
import * as CommonActionType from 'Common/constants';

import { v4 as uuidv4 } from 'uuid';
import Submit from 'components/react-validation/components/submit';
// import { isEmpty } from 'lodash';
import { Dropdown } from 'components/Dropdown/Dropdown';
import word from 'assets/img/file_word.png';
import excel from 'assets/img/file_excel.png';
import pdf from 'assets/img/file_pdf.png';
import ppt from 'assets/img/file_pp.png';
import video from 'assets/img/file_video.png';
import other from 'assets/img/file_other.png';
import { isMobile } from 'react-device-detect';
import PreviewVideoWO from 'Work-Orders/Components/PreviewVideoWO';
import { PreviewImage } from 'components/PreviewImage';
import Linkify from 'react-linkify';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Moment from 'moment';
import { withRouter } from 'react-router-dom';
import * as ProjectActionType from 'Projects/constants';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { generatePdfThumbnail } from 'helper/generate-pdf-thumbnail';
import * as ColorHelper from 'helper/color-helper';
import house_icon from 'assets/img/house.svg';
import to_do_list_icon from 'assets/img/to-do-list.svg';
import './inventory.css';
import { InventoryEditItemModal } from './inventoryEditItem';
import { InventoryItemView } from './inventoryViewItem';

const monthYearType = {
  month: 0,
  year: 1
};

const dateType = {
  coe: 0,
  purchaseDate: 1
};

const warrantyTypeSelection = [{ text: 'COE', value: dateType.coe }, { text: 'Purchase date', value: dateType.purchaseDate }];
const warrantyDateTimeSelection = [{ text: 'months', value: monthYearType.month }, { text: 'years', value: monthYearType.year }];

class EditInventoryItems extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    dispatch: PropTypes.func,
    projectId: PropTypes.string,
    isViewDetail: PropTypes.bool,
    location: PropTypes.any,
    history: PropTypes.any,
    onEditInventoryItems: PropTypes.func,
    inventoryItemProfile: PropTypes.object,
    breadcrumbsHistory: PropTypes.string,
    onToggleLotInstalled: PropTypes.func,
    categoryDropdownList: PropTypes.array,
    onFetchListInventoryItem: PropTypes.func,
    onCancelEditInventoryItems: PropTypes.func,
    onOpenMaintenanceTasks: PropTypes.func,
    inventoryItemId: PropTypes.string,
    action: PropTypes.string,
    ProjectAWSCredential: PropTypes.any
  }
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      model: null,
      mfg: null,
      note: null,
      style: null,
      category: null,
      categoryList: [],
      calendarDate: null,
      calendarDateError: false,
      warrantyExpiration: {
        warrantyDate: null,
        warrantyType: warrantyTypeSelection[0],
        warrantyMonthYear: warrantyDateTimeSelection[0]
      },
      cancelUploadList: {},
      deleteUploadList: {},
      listImages: [],
      files: [],
      imagePreview: null,
      isAttachment: true,
      showDialog: false,
      openSelectedCalendarDate: false,
      isViewDetail: this.props.isViewDetail,
      showItemEditModal: false,
      showItemViewModal: false,
      itemDetail: null
    };
  }

  componentDidMount() {
    this.onFetchListCategory();

    if (this.props.inventoryItemId) {
      this.onGetInventoryProfile(this.props.inventoryItemId);
    }

    window.scrollTo(0, 0);

    this.primaryColor = document.body.style.getPropertyValue('--primary-color');
    document.body.style.setProperty('--light-primary-color', ColorHelper.changeBrightness(this.primaryColor, 200));
    document.body.style.setProperty('--primary-text-color', ColorHelper.getContrastColorYIQ(this.primaryColor));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.action === ProjectActionType.GET_INVENTORY_ITEM_IMAGES_SUCCESS) {
      this.setState({
        ...this.state,
        listImages: nextProps.inventoryItemProfile.images
      });
    }

    if (nextProps.action === ProjectActionType.GET_INVENTORY_ITEM_PROFILE_SUCCESS) {
      this.setState({
        listImages: nextProps.inventoryItemProfile.images,

        warrantyExpiration: {
          warrantyDate: nextProps.inventoryItemProfile.warrantyExpirationIntValue,
          warrantyMonthYear: nextProps.inventoryItemProfile.warrantyExpirationType === 2 ? warrantyDateTimeSelection[0] : warrantyDateTimeSelection[nextProps.inventoryItemProfile.warrantyExpirationTimeUnit],
          warrantyType: nextProps.inventoryItemProfile.warrantyExpirationType === 2 ? warrantyTypeSelection[0] : warrantyTypeSelection[nextProps.inventoryItemProfile.warrantyExpirationType]
        },

        calendarDate: nextProps.inventoryItemProfile.warrantyExpirationDateValue ? Moment(nextProps.inventoryItemProfile.warrantyExpirationDateValue) : null,
        name: nextProps.inventoryItemProfile.name,
        model: nextProps.inventoryItemProfile.model,
        mfg: nextProps.inventoryItemProfile.mfg,
        note: nextProps.inventoryItemProfile.note,
        style: nextProps.inventoryItemProfile.style,
        openSelectedCalendarDate: nextProps.inventoryItemProfile.warrantyExpirationType === 2,
        hiCategoryId: nextProps.inventoryItemProfile.hiCategoryId,
        totalInstalledLot: nextProps.inventoryItemProfile.totalInstalledLot,
        totalMaintenanceTask: nextProps.inventoryItemProfile.totalMaintenanceTask,
        attachments: nextProps.inventoryItemProfile.attachments
      });
    }

    if (nextProps.action === ProjectActionType.GET_INVENTORY_ITEM_ATTACHMENT_SUCCESS) {
      this.setState({
        attachments: nextProps.inventoryItemProfile.attachments
      });
    }

    if (this.props.categoryDropdownList !== nextProps.categoryDropdownList) {
      const newList = nextProps.categoryDropdownList.map(el => {
        return {
          text: el.name,
          value: el.id
        };
      });
      this.setState({
        categoryList: newList
      });
    }

    if (this.props.categoryDropdownList) {
      let obj = this.props.categoryDropdownList.find(el => el.id === this.props.inventoryItemProfile.hiCategoryId);
      if (obj) {
        const newObject = {
          text: obj.name,
          value: obj.id
        };
        this.setState({
          category: newObject
        });
      }
    }
  }

  convertHex = (hexCode, opacity) => {
    var hex = hexCode.replace('#', '');

    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  }

  getContrastYIQ = (hexcolor1) => {
    let hexcolor = hexcolor1.replace('#', '');
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
  }

  onGetInventoryProfile = (id, callback) => {
    this.props.dispatch({
      type: ProjectActionType.GET_INVENTORY_ITEM_PROFILE_ASYNC,
      params: {
        id: id
      },
      callback
    });
  }

  onGetInventoryItemDetail = (id) => {
    this.props.dispatch({
      type: ProjectActionType.GET_INVENTORY_ITEM_DETAIL_ASYNC,
      params: {
        id: id
      },
      callback: (data) => {
        this.setState({
          itemDetail: data.data
        })
      }
    });
  }

  onClose = () => {
    this.props.onClose();
  }

  onSubmit = (e) => {
    const { category, warrantyExpiration, name, model, mfg, style, note } = this.state;
    const { inventoryItemProfile, dispatch } = this.props;
    let selectedDate = null;

    e.preventDefault();

    if (this.calendarDate) {
      if (this.calendarDate.state.selectedDate) {
        selectedDate = formatTimezoneDateTime(this.calendarDate.state.selectedDate);
      }
      else if (this.calendarDate.state.inputValue === '') {
        selectedDate = null;
      }
      else {
        return;
      }
    }

    // dispatch({
    //   type: ProjectActionType.EDIT_INVENTORY_ITEM_ASYNC,
    //   params: {
    //     Id: inventoryItemProfile.id,
    //     categoryId: category? category.value : '',
    //     name: name,
    //     model: model,
    //     mfg: mfg,
    //     style: style,
    //     warrantyExpirationType: this.state.openSelectedCalendarDate ? '2' : warrantyExpiration.warrantyType.value,
    //     warrantyExpirationIntValue: this.state.openSelectedCalendarDate ? null : (warrantyExpiration.warrantyDate === null ? null : warrantyExpiration.warrantyDate),
    //     warrantyExpirationTimeUnit: this.state.openSelectedCalendarDate ? null : warrantyExpiration.warrantyMonthYear.value,

    //     warrantyExpirationDateValue: this.state.openSelectedCalendarDate ? selectedDate : null,
    //     note: note
    //   },
    //   callback: () => { this.onChangeMode(true); }
    // });
  }

  onDrop = (accepted, rejected) => {
    const { listImages } = this.state;
    if (rejected.length) {
      const errorMsg = 'Only PNG, JPG, JPEG, BMP, TIFF supported.';
      this.setState({
        errorMsg: errorMsg
      });
    } else if ((accepted.length + listImages.length) > 5) {
      this.setState({
        errorMsg: 'Maximum 5 files only.'
      });
    } else {
      this.handleFileUpload(accepted);
    }
  }

  onDropAttachments = (accepted) => {
    if ((accepted.length + (this.props.inventoryItemProfile && this.props.inventoryItemProfile.attachments && this.props.inventoryItemProfile.attachments.length)) > 5) {
      const error = 'Maximum 5 files uploaded.';
      this.setState({
        errorAttachmentMsg: error
      });
    } else {
      let newFiles = [...this.state.files];
      accepted.map((file) => {
        file.uploadId = _.uniqueId(); //uuidv4();
        newFiles.push(file);
        this.setState({
          files: newFiles
        });
      });
      this.handleUploadFile(accepted);
    }
  }
  //UPLOAD WITH LOADING ATTACHMENT
  handleUploadFile = (files) => {
    //call api to get key AWS
    this.props.dispatch({
      type: ProjectActionType.SETUP_PROJECT_DOCUMENT_AWS_ASYNC,
      params: {
        resourcePath: `projects/${this.props.projectId}/home-inventory/inventory-attachment-file`
      },
      callback: () => this.handleUploadFileToS3(files)
    });
  }

  handleUploadFileToS3 = (files) => {
    const { ProjectAWSCredential } = this.props;
    files.map((file) => {
      this.props.dispatch({
        type: ProjectActionType.UPLOAD_PROJECT_DOCUMENT_TO_S3_ASYNC,
        params: {
          projectId: this.props.projectId,
          config: ProjectAWSCredential,
          file: file
        },
        callback: this.callbackHandleUploadFileToS3(file.name)
      });
    });
  }

  callbackHandleUploadFileToS3 = name => (status, data) => {
    if (status === 'pending') {
      const { cancelUploadList } = this.state;
      cancelUploadList[data.uploadId] = data.cancelUpload;
      this.setState({
        cancelUploadList
      });
    } else if (status === 'delete') {
      const { deleteUploadList } = this.state;
      deleteUploadList[data.uploadId] = data.deleteFile;
      this.setState({
        deleteUploadList
      });
    } else {
      this.handleUploadFileToServer(data.data, name);
    }
  }

  handleUploadFileToServer = (data, name) => {
    this.props.dispatch({
      type: ProjectActionType.ADD_INVENTORY_ITEM_ATTACHMENT_ASYNC,
      params: {
        inventoryId: this.props.inventoryItemProfile.id,
        data: {
          fileName: name,
          url: data.Location,
          key: data.Key
        }
      },
      callback: (status, res) => {
        if (status) {
          this.setState({
            files: []
          });
        }
      }
    });
  }
  //UPLOAD WITH LOADING ATTACHMENT
  onClearError = (name) => {
    this.setState({ [name]: null });
  };

  renderError = (errorMsg, name) => {

    if (errorMsg) {
      setTimeout(() => this.onClearError(name), 3000);
      return (
        <div
          className='alert alert-danger'
          style={{ width: '100%', margin: 5 }}
        >
          <p style={{ fontSize: 14, marginBottom: -5, marginTop: -5 }}>{errorMsg}</p>
          <i
            className='fa fa-close'
            style={{
              position: 'absolute',
              top: 5,
              right: 10,
              cursor: 'pointer'
            }}
            onClick={() => this.onClearError(name)}
          />
        </div>
      );
    }

    return null;
  };

  handleFileUpload = (files, isAttachment) => {
    const { projectId } = this.props;
    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: isAttachment ? `projects/${projectId}/home-inventory/inventory-attachment-file` : `projects/${projectId}/home-inventory/inventory-items-image`
      },
      callback: awsCredential => {
        this.awsCredential = awsCredential;

        files.map(file => {
          file.uploadId = uuidv4();
          if (file.type === 'application/pdf') {
            //handle get pdf thumbnail
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential
              },
              callback: (status, callbackData) => {
                if (status === 'pending') {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                    callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList
                  });
                } else if (status === 'delete') {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                    callbackData.deleteFile;
                  this.setState({
                    deleteUploadList
                  });
                } else if (status === true) {
                  callbackData.name = file.name;
                  const data = file.preview;
                  generatePdfThumbnail(
                    data,
                    this.handlePdfThumbnail,
                    callbackData
                  );
                }
              }
            });
          } else {
            //handle image file
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential
              },
              callback: (status, callbackData) => {
                callbackData.name = file.name;

                if (status === 'pending') {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                    callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList
                  });
                } else if (status === 'delete') {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                    callbackData.deleteFile;
                  this.setState({
                    deleteUploadList
                  });
                } else if (status === true) {
                  if (isAttachment) {
                    this.getFileUrl(callbackData, callbackData);
                  } else {
                    this.getImageUrl(callbackData, callbackData);
                  }
                }
              }
            });
          }
        });
      }
    });
  }

  handlePdfThumbnail = (thumbnail, fileDataS3) => {
    const { projectId } = this.props;

    thumbnail.name = uuidv4();

    this.props.dispatch({
      type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_HOME_INVENTORY_ASYNC,
      paramsUpload: {
        projectId,
        file: thumbnail,
        config: {
          ...this.awsCredential,
          path: `${this.awsCredential.path}/thumbnail`
        }
      },
      callback: (status, callbackData) => {
        if (status === true) {
          this.getFileUrl(fileDataS3, callbackData);
        }
      }
    });
  };

  getFileUrl = (fileData) => {
    const { inventoryItemProfile } = this.props;
    this.props.dispatch({
      type: ProjectActionType.ADD_INVENTORY_ITEM_ATTACHMENT_ASYNC,
      params: {
        id: this.props.inventoryItemProfile.id,
        data: {
          fileName: fileData.name,
          key: fileData.data.Key,
          url: fileData.data.Location
        }
      }, callback: () => {
        this.props.dispatch({
          type: ProjectActionType.GET_INVENTORY_ITEM_ATTACHMENT_ASYNC,
          params: {
            id: inventoryItemProfile.id
          }
        });
      }
    });
  }

  getImageUrl = (fileData) => {
    const { inventoryItemProfile } = this.props;
    this.props.dispatch({
      type: ProjectActionType.ADD_INVENTORY_ITEM_IMAGES_ASYNC,
      params: {
        id: this.props.inventoryItemProfile.id,
        data: {
          fileName: fileData.name,
          key: fileData.data.Key,
          url: fileData.data.Location,
          thumbnailKey: fileData.data.Key,
          thumbnailUrl: fileData.data.Location
        }
      }, callback: () => {
        this.props.dispatch({
          type: ProjectActionType.GET_INVENTORY_ITEM_IMAGES_ASYNC,
          params: {
            id: inventoryItemProfile.id
          }
        });
      }
    });
  }

  onTogglePreviewImages = (url) => {
    this.setState({
      imagePreview: url
    });
  }

  onRemoveFiles = (id) => {
    const { inventoryItemProfile } = this.props;
    this.props.dispatch({
      type: ProjectActionType.DELETE_INVENTORY_ITEM_ATTACHMENT_ASYNC,
      params: {
        id: id
      }, callback: () => {
        this.props.dispatch({
          type: ProjectActionType.GET_INVENTORY_ITEM_ATTACHMENT_ASYNC,
          params: {
            id: inventoryItemProfile.id
          }
        });
      }
    });
  }

  onRemoveImages = (id) => {
    const { inventoryItemProfile } = this.props;
    this.props.dispatch({
      type: ProjectActionType.DELETE_INVENTORY_ITEM_IMAGES_ASYNC,
      params: {
        imageId: id
      }, callback: () => {
        this.props.dispatch({
          type: ProjectActionType.GET_INVENTORY_ITEM_IMAGES_ASYNC,
          params: {
            id: inventoryItemProfile.id
          }
        });
      }
    });
  }

  onToggleLotInstalled = () => {
    this.props.onToggleLotInstalled();
  }

  onSetNewMaintenanceTask = () => {
    this.props.onOpenMaintenanceTasks();
  }

  onChange = (e) => {
    this.setState({
      category: e.value
    });
  }

  onChangeMode = (isViewMode) => {
    this.setState({
      isViewDetail: isViewMode
    },
      () => {
        this.onGetInventoryProfile(this.props.inventoryItemId);
      });
  }

  onChangeWarrantyDropdown = (e, type) => {
    const { warrantyExpiration } = this.state;
    this.setState({
      warrantyExpiration: { ...warrantyExpiration, [type]: e.value }
    });
  }

  onPreviewFilesAttachment = (file) => {
    const extension = file.fileName.split('.').pop().toLowerCase();
    const imageType = ['jpg', 'jpeg', 'png', 'gif'];
    const videoType = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    if (imageType.includes(extension)) {
      this.setState({
        show: true,
        previewUrl: file.url
      });
    }
    if (extension === 'pdf') {
      this.setState({
        isPreviewPDF: file.url
      }, () => {
        if (isMobile) {
          window.open(this.state.isPreviewPDF, '_blank');
        }
      });
    }
    if (videoType.includes(extension)) {
      this.setState({
        showDialog: true,
        videoUrl: file.url
      });
    }
  }

  handleClose = () => {
    this.setState({ show: false, previewUrl: null });
  }

  handleCloseVideo = (callback) => {
    this.setState({ showDialog: false, videoUrl: null }, callback);
  }

  renderFileTypeIcon = (item) => {
    const extWord = ['doc', 'docx'];
    const extExcel = ['xls', 'xlsx'];
    const extPpt = ['ppt', 'pptx'];
    const extImage = ['jpg', 'jpeg', 'png', 'gif'];
    const extVideo = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    const ext = item.fileName.split('.').pop().toLowerCase();
    if (extWord.includes(ext)) { return word; }
    else if (extExcel.includes(ext)) { return excel; }
    else if (extPpt.includes(ext)) { return ppt; }
    else if (extPpt.includes(ext)) { return ppt; }
    else if (extVideo.includes(ext)) { return video; }
    else if (ext === 'pdf') { return pdf; }
    else if (extImage.includes(ext)) { return item.url; }
    else { return other; }
  }

  renderFileUpload = () => {
    const { files } = this.state;
    const { inventoryItemProfile } = this.props;
    return (
      <ul className='inventory-attachments-files-list row'>
        {(inventoryItemProfile && inventoryItemProfile.attachments.length > 0) &&
          inventoryItemProfile.attachments.map(file =>
            <li key={file.fileName}>
              <img style={{
                width: 50,
                height: 50,
                marginLeft: 15,
                marginRight: 10,
                borderRadius: 1,
                verticalAlign: 'top',
                backgroundImage: `url(${this.renderFileTypeIcon(file)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                cursor: "pointer",
                display: 'inline-block',
              }} onClick={this.state.isViewDetail ? () => this.onPreviewFilesAttachment(file) : () => { }} />
              <div style={{ display: 'inline-block', textOverflow: 'ellipsis', maxWidth: '80%', whiteSpace: 'nowrap', marginTop: '15px' }} className='file-info'>
                <span onClick={this.state.isViewDetail ? () => this.onPreviewFilesAttachment(file) : () => { }} >{file.fileName}</span>
              </div>
              <div style={{ display: 'inline-block', marginLeft: "10px" }} className='remove-button-wrapper-item' >
                {this.state.isViewDetail ? <i className='fa fa-eye view-icon func-icon inventory-preview' onClick={this.state.isViewDetail ? () => this.onPreviewFilesAttachment(file) : () => { }} />
                  : ""}
                <i className='remove-button-item icon-remove-ic' style={{ marginLeft: "6px" }} onClick={() => this.onRemoveFiles(file.id)} />
              </div>
            </li>
          )}
        {
          files.map(file =>
            <li key={file.name}>
              <div style={{ display: 'inline-block' }} className='logo-loading'>
                <i style={{ fontSize: 20, width: 35, verticalAlign: 'super', marginTop: 15 }} className='fa fa-spin fa-spinner loading-ic' />
              </div>
              <div style={{ display: 'inline-block' }} className='file-info'>
                <p>{file.name}</p>
              </div>
            </li>
          )
        }
      </ul>
    );
  }

  onToggleCalendarDate = () => {
    this.setState({
      openSelectedCalendarDate: true
    });
  }
  onToggleRegularDate = () => {
    this.setState({
      openSelectedCalendarDate: false
    });
  }

  onFetchListCategory = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_CATEGORY_DROPDOWN_ASYNC,
      params: {
        projectId: this.props.projectId
      }
    });
  }

  handleItemEditOpenModal = () => {
    this.setState({
      showItemEditModal: true,
    }, () => {
      this.onGetInventoryItemDetail(this.props.inventoryItemId)
    });
  };

  handleItemViewOpenModal = () => {
    this.setState({
      showItemViewModal: true,
    }, () => {
      this.onGetInventoryItemDetail(this.props.inventoryItemId)
    });
  };

  handleCloseEditItemModal = () => {
    this.setState({ showItemEditModal: false });
  };

  handleCloseViewItemModal = () => {
    this.setState({ showItemViewModal: false });
  };

  onChangeDateWarranty = (e) => {
    const { warrantyExpiration } = this.state;
    const warrantyDate = e.target.value;
    if (warrantyDate <= 999) {
      if (warrantyDate >= 0) {
        this.setState({ warrantyExpiration: { ...warrantyExpiration, warrantyDate: e.target.value }, calendarDate: null });
      } else {
        this.setState({ warrantyExpiration: { ...warrantyExpiration, warrantyDate: null } });
      }
    }
  }

  onChangeDate = (value) => {
    this.setState({ calendarDate: value });

    if (Moment(value, 'MM/DD/YYYY', true).isValid() || value === '') {
      this.setState({ calendarDateError: false });
    }
    else {
      this.setState({ calendarDateError: true });
    }
  }

  renderInventoryValue = value => {
    if (value) {
      return <Linkify><strong>{value}</strong></Linkify>;
    }
    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  renderCategoryValue = (id) => {
    let obj = this.props.categoryDropdownList.find(el => el.id === id);
    if (obj) {
      return <Linkify><strong>{obj.name}</strong></Linkify>;
    }
    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  renderInventoryWarrantyValue = () => {
    const { warrantyExpirationDateValue, warrantyExpirationIntValue, warrantyExpirationTimeUnit, warrantyExpirationType } = this.state;
    if (warrantyExpirationDateValue === null && warrantyExpirationIntValue === null) {
      return <span style={{ opacity: '.5' }}>(Not specified)</span>;
    }
    if (warrantyExpirationDateValue === null) {
      return <strong>{warrantyExpirationIntValue} {warrantyExpirationTimeUnit === 0 ? ((warrantyExpirationIntValue > 1) ? 'months' : 'month') : ((warrantyExpirationIntValue > 1) ? 'years' : 'year')} from {warrantyExpirationType === 0 ? 'COE'
        : 'Purchase Date'
      }</strong>;
    }
    if (warrantyExpirationDateValue !== null) {
      return <strong>{Moment(warrantyExpirationDateValue).format('MM/DD/YYYY')}</strong>;
    }
    return '';
  }

  onChangeText = (e, type) => {
    this.setState({
      [type]: e.target.value
    });
  }

  render() {
    const { name, note, model, style, mfg, hiCategoryId, totalInstalledLot, totalMaintenanceTask, attachments, showItemEditModal, showItemViewModal } = this.state;
    const { category, categoryList, listImages, imagePreview, files, openSelectedCalendarDate } = this.state;
    const { breadcrumbsHistory } = this.props;
    const { isViewDetail } = this.state;
    const acceptFileType = 'image/jpeg, image/png , image/bmp, image/jpg, image/tiff, image/webp, .webp';
    const breadcrumbs = [
      { title: 'Inventory items', url: breadcrumbsHistory, onCustomAction: this.props.onClose },
      { title: `${name}`, url: '' }
    ];

    const calendarDateErrorRender = (
      this.state.calendarDateError
        ? <span className='text-danger' style={{ fontSize: 12, marginTop: 5 }}>Invalid Date</span> : null
    );

    return (
      <React.Fragment>
        <div className='home-libraries-inventory'>
          <h4 style={{ height: 30, marginTop: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</h4>
          <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit}>
            <div><Breadcrumb breadcrumbs={breadcrumbs} /></div>
            {isViewDetail && this.state.isPreviewPDF && !isMobile && [
              <embed src={this.state.isPreviewPDF} className='pdf-preview-dialog' ref={ref => { this.embedPreview = ref; }} />,
              <i onClick={() => this.setState({ isPreviewPDF: null })} className='close-embed-preview fa fa-close' />
            ]}

            {isViewDetail && <PreviewImage
              show={this.state.show}
              imageUrl={this.state.previewUrl}
              handleClose={this.handleClose}
            />}

            {isViewDetail && this.state.videoUrl && [
              <PreviewVideoWO
                // loading
                data={this.state.videoUrl}
                showDialog={this.state.showDialog}
                handleCloseVideo={this.handleCloseVideo}
              />
            ]}
            <div className={isViewDetail ? 'add-new-category-item row' : 'edit-new-category-item row'}>
              <div className='col-md-6 col-xs-6'>
                <div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>Name {!isViewDetail && <strong className='text-danger'>*</strong>}</label>
                    {!isViewDetail ? <input
                      name='name'
                      ref='name'
                      placeholder='Name'
                      className='form-control'
                      autoFocus
                      value={name}
                      max='254'
                      maxLength='254'
                      onChange={(e) => this.onChangeText(e, 'name')}
                      // errorMsg={this.props.errorMsg}
                      validations={[Vali.required, Vali.maxlength]} />
                      : <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          name ? name : null
                        )}
                      </div>
                    }
                  </div>
                </div>
                <div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>Inventory {!isViewDetail && <strong className='text-danger'>*</strong>}</label>
                    {!isViewDetail ? <Dropdown
                      onChange={(e) => this.onChange(e)}
                      className='filestring-dropdown filter-dropdown'
                      value={category}
                      // onRemote={this.onFetchListCategory}
                      options={categoryList}
                      style={{ width: '100%' }}
                      optionLabel='text'
                      filter={true}
                      placeholder='Select Any'
                      errorMessage='This information is required.'
                      ref={ref => {
                        this.categoryDropdown = ref;
                      }} />
                      : <div className=' col-sm-9 control-label name form-text-label'>
                        {this.renderCategoryValue(
                          hiCategoryId ? hiCategoryId : null
                        )}
                      </div>}
                  </div>
                </div>
                {/* <div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>MFG/Provider {!isViewDetail && <strong className='text-danger'>*</strong>}</label>
                    {!isViewDetail ? <input
                      name='mfg'
                      ref='mfg'
                      placeholder='MFG'
                      className='form-control'
                      value={mfg}
                      max='254'
                      maxLength='254'
                      onChange={(e) => this.onChangeText(e, 'mfg')}
                      // errorMsg={this.props.errorMsg}
                      validations={[Vali.required, Vali.maxlength]} />
                      : <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          mfg ? mfg : null
                        )}
                      </div>}
                  </div>
                </div>
                <div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>Model/Type {!isViewDetail && <strong className='text-danger'>*</strong>}</label>
                    {!isViewDetail ? <input
                      name='model'
                      ref='model'
                      placeholder='Model'
                      className='form-control'
                      value={model}
                      max='254'
                      maxLength='254'
                      onChange={(e) => this.onChangeText(e, 'model')}
                      // errorMsg={this.props.errorMsg}
                      validations={[Vali.required, Vali.maxlength]} />
                      : <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          model ? model : null
                        )}
                      </div>}
                  </div>
                </div>
                <div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>MFG Links</label>
                    {!isViewDetail ? <textarea
                      style={{ minHeight: 100 }}
                      name='note'
                      ref='note'
                      className='form-control'
                      value={note}
                      max='1000'
                      maxLength='1000'
                      onChange={(e) => this.onChangeText(e, 'note')}
                    />
                      : <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} className='col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          note ? note : null
                        )}
                      </div>}
                  </div>
                </div> */}
                {/* <div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>Style</label>
                    {!isViewDetail ? <input
                      name='style'
                      ref='style'
                      placeholder='Style'
                      className='form-control'
                      value={style}
                      max='254'
                      maxLength='254'
                      onChange={(e) => this.onChangeText(e, 'style')}
                    />
                      : <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          style ? style : null
                        )}
                      </div>}
                  </div>
                </div> */}
                {/*<div className={isViewDetail ? 'view-details' : 'form-group'}>
                  <div className={isViewDetail ? 'row col-sm-12 margin-bottom-20' : 'row col-sm-12 margin-bottom-10'}>
                    <div className={!isViewDetail ? 'margin-left-0 row' : ''}>
                      <label className={isViewDetail ? 'col-sm-3 font-normal control-label' : ''}>Limited warranty period</label>
                    </div>
                    <div className={!isViewDetail ? 'row margin-left-miner-30' : ''}>
                      <div className={!isViewDetail ? 'col-md-8 col-xs-12 col-sm-12' : ''}>
                        {!isViewDetail
                          ? (!openSelectedCalendarDate ? <div className='warranty-date'>
                            <input
                              min='0'
                              style={{ width: 50, border: 'none', borderBottom: '1px solid lightgray' }}
                              className='date-warranty'
                              ref={ref => {
                                this.warrantyDate = ref;
                              }}
                              type='number'
                              name='warrantyDate'
                              onFocus={() => this.setState({ warrantyExpiration: { ...this.state.warrantyExpiration, warrantyDate: null } })}
                              value={this.state.warrantyExpiration.warrantyDate || ''}
                              onChange={this.onChangeDateWarranty}
                            />
                            <Dropdown
                              onChange={(e) => this.onChangeWarrantyDropdown(e, 'warrantyMonthYear')}
                              className='filestring-dropdown filter-dropdown'
                              value={this.state.warrantyExpiration.warrantyMonthYear}
                              options={warrantyDateTimeSelection}
                              style={{ width: '30%', display: 'inline-block', marginLeft: 10, marginRight: 5 }}
                              optionLabel='text'
                              placeholder='Any'
                              ref={ref => {
                                this.warrantyMonthYear = ref;
                              }} />
                            <span>from</span>
                            <Dropdown
                              onChange={(e) => this.onChangeWarrantyDropdown(e, 'warrantyType')}
                              className='filestring-dropdown filter-dropdown'
                              value={this.state.warrantyExpiration.warrantyType}
                              options={warrantyTypeSelection}
                              style={{ width: '41%', display: 'inline-block', marginLeft: 5, marginRight: 5 }}
                              optionLabel='text'
                              placeholder='Any'
                              ref={ref => {
                                this.warrantyType = ref;
                              }} />
                          </div> : <div className='warranty-date'>
                            <Datetime
                              ref={ref => { this.calendarDate = ref; }}
                              inputProps={{ placeholder: 'MM/DD/YYYY' }}
                              timeFormat={false}
                              value={this.state.calendarDate}
                              onChange={calendarDate => this.onChangeDate(calendarDate)}
                              closeOnSelect={true} />{calendarDateErrorRender}</div>)
                          : <div style={{ marginLeft: -10 }} className='col-sm-9 control-label name form-text-label'>
                            {this.renderInventoryWarrantyValue()}
                          </div>}
                      </div>
                      {!isViewDetail &&
                        <div style={{ marginTop: 15, textAlign: 'center' }} className='col-md-4 col-xs-12 col-sm-12'>
                          <div className='inventory-calendar-warranty'>
                            <div style={!openSelectedCalendarDate ? { backgroundColor: 'lightgray', borderRadius: '50%' } : {}} onClick={this.onToggleRegularDate} className='regular-date'><span style={{ marginLeft: 9, fontSize: 30 }}><img style={{ marginBottom: 6 }} src={regularDate} /></span></div>
                            <div style={openSelectedCalendarDate ? { backgroundColor: 'lightgray', borderRadius: '50%' } : {}} onClick={this.onToggleCalendarDate} className='calendar-date'><span style={{ marginLeft: 8, fontSize: 30 }}><img style={{ marginBottom: 6 }} src={calendarDateImg} /></span></div>
                          </div>
                        </div>}
                    </div>
                  </div>
                </div>*/}

                {isViewDetail && (
                  <div>
                    <button
                      onClick={() => this.handleItemEditOpenModal()}
                      className="btn btn-primary btn-siteone"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => this.handleItemViewOpenModal()}
                      className="btn btn-primary btn-siteone"
                    >
                      View
                    </button>
                  </div>
                )}

                {!isViewDetail &&
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <span className='btn btn-siteone-default' onClick={() => this.onChangeMode(true)}>Cancel</span>
                      <Submit className='btn btn-primary btn-siteone'>Save</Submit>
                    </div>
                  </div>
                }
              </div>
              <div className='col-md-6 col-xs-6'>
                <div className='preview-inventory-items-image'>
                  {/* <div className='container-fluid'>
                      <div className='row'>
                        <div className='col-md-12 col-xs-12'>
                          {imagePreview && <img
                            className='empty-category-image'
                            src={imagePreview || !isEmpty(listImages) ? imagePreview : emptyImages}
                            alt='no-files'
                          />}
                          { !imagePreview && <img
                            className='empty-category-image'
                            src={this.state.listImages && this.state.listImages[0] ? this.state.listImages[0].url : emptyImages}
                            alt='no-files'
                          />}
                        </div>
                      </div>
                    </div> */}

                  <div className='container-fluid'>
                    <div className='list-thumbnail-image-after-upload'>
                      {/* <div className='row'>                          
                          <div style={{height: 70, display: 'flex', justifyContent: 'center'}} className='col-md-12 col-sm-6 col-xs-12'>
                            {!isEmpty(listImages) && (
                              listImages.map((el, index) => {
                                return (
                                  <div key={index} className='image-file-after-upload col-md-2 col-xs-4 col-lg-2'>
                                    <span onClick={() => this.onRemoveImages(el.id)} className='close'>&times;</span>
                                    <img className='category-img-item' onClick={() => this.onTogglePreviewImages(el.url)} src={el.url} />
                                  </div>
                                );
                              })
                            )}
                            {listImages.length < 5 && <div className='image-file-after-upload col-md-2 col-xs-4 col-lg-2'>
                              <Dropzone
                                disableClick
                                accept={acceptFileType}
                                ref={node => {
                                  this.dropzoneRef = node;
                                }}
                                className='category-images-dropzone'
                                onDrop={this.onDrop.bind(this)}
                              >
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.dropzoneRef.open();
                                  }}
                                  className='add-image-category btn btn-primary btn-siteone-default'
                                >
                                  <img
                                    src={plusIcon}
                                  />
                                </button>
                              </Dropzone>
                            </div>}
                          </div>
                        </div> */}
                    </div>
                    {this.renderError(this.state.errorMsg, 'errorMsg')}
                  </div>
                </div>

                {/* installs lot */}
                <div className='row'>
                  <div style={{ marginBottom: 20 }} className='col-md-12 col-xs-12'>
                    <button
                      onClick={this.onToggleLotInstalled}
                      className='form-control btn-primary-empty'
                      style={{ borderColor: 'var(--primary-color)', textAlign: 'left', width: 'auto' }}>
                      <img src={house_icon} style={{ width: '14px', marginRight: '3px' }} /> Installed in {totalInstalledLot} lots.</button>
                  </div>
                </div>

                {/* alerts  */}
                <div className='row'>
                  <div style={{ marginBottom: 20 }} className='col-md-12 col-xs-12'>
                    <div className='input-group'>
                      <button onClick={this.onSetNewMaintenanceTask}
                        className='form-control btn-primary-empty'
                        style={{ borderColor: 'var(--primary-color)', textAlign: 'left' }}>
                        <img src={to_do_list_icon} style={{ width: '14px', marginRight: '3px' }} />{` ${totalMaintenanceTask} maintenance tasks`}</button>
                      <span className='input-group-btn' style={{ width: 'auto' }}>
                        <button className='btn btn-secondary'
                          onClick={this.onSetNewMaintenanceTask}
                          style={{
                            padding: '4px 10px',
                            fontSize: '16px',
                            backgroundColor: 'var(--primary-color)',
                            height: '40px',
                            borderColor: 'var(--primary-color)',
                            color: 'var(--primary-text-color)',
                            opacity: 1

                          }}>SET</button>
                      </span>
                    </div>
                  </div>
                </div>

                {/* attachments */}
                {/* <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <label className='font-normal'>
                            Attachments
                      </label>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='dropzone-attachment-inventory-items col-md-12 col-xs-12'>
                      {this.renderError(this.state.errorAttachmentMsg, 'errorAttachmentMsg')}
                      <Dropzone
                        disableClick
                        ref={node => { this.dropzoneAttachments = node; }}
                        onDrop={this.onDropAttachments}
                        className='inventory-attachments-dropzone'
                      >
                        <div className='upload-block'>
                          <span className='files-upload-ic'>
                            <i className='fa fa-cloud-upload' />
                          </span>
                            Drag files here or{' '}
                          <span className='files-browse-txt' onClick={() => { this.dropzoneAttachments.open(); }}> browse. </span>
                        </div>
                      </Dropzone>
                    </div>
                    <div className='col-md-12 col-xs-12'>
                      <div style={{marginLeft: -20}} className='inventory-attachments-files-list container-fluid'>
                        {(attachments && attachments.length) || files.length ? this.renderFileUpload() : ''}
                      </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </Form>
          {showItemEditModal && <InventoryEditItemModal
            isOpen={showItemEditModal}
            closeModal={this.handleCloseEditItemModal}
            accept=".pdf,.docx,.png,.jpg,.webp"
            inventoryItemId={this.props.inventoryItemId}
            itemDetails={this.state.itemDetail}
            projectId={this.props.projectId}
            onChangeMode={(mode) => this.onChangeMode(mode)}
            // onDrop={this.handleFileDrop}
            // selectedCategory={editCategorySelected}
            dispatch={this.props.dispatch}
            // getItemsByCategory={this.props.getItemsByCategory}
            // fetchInventoryCategories={this.fetchInventoryCategoriesHo}
            // itemDetails={this.state.itemDetailsForEdit}
            isEdit={true}
          // getInventoryDetails={this.getInventoryDetails}
          />}
          {
            showItemViewModal && <InventoryItemView
              isOpen={showItemViewModal}
              closeModal={this.handleCloseViewItemModal}
              openEditModal={this.handleItemEditOpenModal}
              itemDetails={this.state.itemDetail}
            />
          }
        </div>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    action: state.ProjectStore.action,
    categoryDropdownList: state.ProjectStore.categoryDropdownList,
    inventoryItemProfile: state.ProjectStore.inventoryItemProfile,
    ProjectAWSCredential: state.ProjectStore.ProjectAWSCredential
  };
};

export default withRouter(connect(mapStateToProps)(EditInventoryItems));



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/item-edit.js